import type { Dispatch, SetStateAction } from "react";
import type { DataTableSortDirection } from "../../../../../components/table";
import type { SurveyListFilters } from "../../hooks/useGetSurveyList";
import type { SurveyListItemForAdminResponse, SurveyStatus } from "../../types/survey.types";
import SurveyPageContentState from "./SurveyPageContentState";
import SurveyTable from "./SurveyTable";
import { SurveyListTableSkeleton } from "../survey-skeletons";

type SurveyListDataTableProps = {
  surveys: SurveyListItemForAdminResponse[];
  search: string;
  filters: SurveyListFilters;
  setFilters: Dispatch<SetStateAction<SurveyListFilters>>;
  loading: boolean;
  error: string | null;
  onRetry: () => void | Promise<void>;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onRowClick: (survey: SurveyListItemForAdminResponse) => void;
  onEditClick: (survey: SurveyListItemForAdminResponse) => void;
  onDeleteClick: (survey: SurveyListItemForAdminResponse) => void;
  getSurveyStatus: (status: SurveyStatus) => string;
  sortDirections: Partial<Record<"points" | "question_count" | "responses_count", DataTableSortDirection | null>>;
  onColumnSort: (
    columnName: "points" | "question_count" | "responses_count",
    nextDirection: DataTableSortDirection | null,
  ) => void;
};

const SurveyListDataTable = ({
  surveys,
  search,
  filters,
  setFilters,
  loading,
  error,
  onRetry,
  page,
  totalPages,
  onPageChange,
  onRowClick,
  onEditClick,
  onDeleteClick,
  getSurveyStatus,
  sortDirections,
  onColumnSort,
}: SurveyListDataTableProps) => {
  if (loading) {
    return <SurveyListTableSkeleton />;
  }

  return (
    <>
      {!error && (
        <SurveyPageContentState
          hasSurveys={surveys.length > 0}
          search={search}
        />
      )}

      {(error || surveys.length > 0) && (
      <SurveyTable
        surveys={surveys}
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        error={error}
        onRetry={onRetry}
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onRowClick={onRowClick}
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
        getSurveyStatus={getSurveyStatus}
        sortDirections={sortDirections}
        onColumnSort={onColumnSort}
      />
    )}
    </>
  );
};

export default SurveyListDataTable;
